var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 60,
    viewBox: "0 0 141 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4679 23.5494H24.9834V16.6851H48.1398V23.508H40.6553V43.3564H32.4679V23.5494Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4217 16.6851H71.9165V23.508H57.6505V26.8161H71.9165V33.1841H57.6505V36.4922H71.9165V43.315H49.4217V16.6851Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5099 36.5335H84.7352C89.8627 36.5335 90.607 32.3984 90.607 29.876C90.607 28.1807 90.0695 23.5494 84.1563 23.5494H81.5512V36.5335H81.5099ZM73.2811 16.6851H86.7614C95.6518 16.6851 98.7945 23.2599 98.7945 30.0001C98.7945 38.1875 94.4526 43.3564 85.1487 43.3564H73.2811V16.6851Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.621 33.1014L108.098 28.925L105.659 33.1014H99.6215L105.328 24.6658L99.8282 16.6438H105.865L108.098 20.6135L110.373 16.6438H116.41L110.91 24.6658L116.617 33.06H110.621V33.1014Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.04b5c0a77b9ab9f003ea6d73e37998a0.svg";
export { ForwardRef as ReactComponent };